import {
  hapticFeedback,
  type ImpactHapticFeedbackStyle,
  type NotificationHapticFeedbackType,
} from "@telegram-apps/sdk-react";

type vibrationType =
  | ImpactHapticFeedbackStyle
  | NotificationHapticFeedbackType
  | "selection";

const IMPACT_STYLES: ImpactHapticFeedbackStyle[] = [
  "light",
  "medium",
  "heavy",
  "rigid",
  "soft",
];

const NOTIFICATION_TYPES: NotificationHapticFeedbackType[] = [
  "error",
  "success",
  "warning",
];

const isImpactStyle = (type: string): type is ImpactHapticFeedbackStyle =>
  (IMPACT_STYLES as string[]).includes(type);

const isNotificationType = (
  type: string
): type is NotificationHapticFeedbackType =>
  (NOTIFICATION_TYPES as string[]).includes(type);

interface VibratingButtonProps extends React.ComponentProps<"button"> {
  vibrationType?: vibrationType;
  vibrate?: boolean;
}

function VibratingButton({
  children,
  onClick,
  className = "",
  disabled = false,
  vibrate = true,
  vibrationType = "soft",
  ...restProps
}: VibratingButtonProps) {
  const handleVibration = (type: vibrationType) => {
    if (isImpactStyle(type)) {
      if (hapticFeedback.impactOccurred.isAvailable()) {
        hapticFeedback.impactOccurred(type);
      }
    } else if (isNotificationType(type)) {
      if (hapticFeedback.notificationOccurred.isAvailable()) {
        hapticFeedback.notificationOccurred(type);
      }
    } else if (type === "selection") {
      if (hapticFeedback.selectionChanged.isAvailable()) {
        hapticFeedback.selectionChanged();
      }
    }
  };

  const handleClick: React.MouseEventHandler<HTMLButtonElement> = (e) => {
    if (!disabled) {
      if (vibrate) {
        handleVibration(vibrationType);
      }
      onClick?.(e);
    }
  };

  return (
    <button
      className={className}
      onClick={handleClick}
      disabled={disabled}
      {...restProps}
    >
      {children || vibrationType}
    </button>
  );
}
export default VibratingButton;
